export default __webpack_public_path__ + "static/BertholdAkzidenzGroteskBEBo-0c8b737afbaf69ae681759084e766118.ttf";